// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useScanProxyApiClient } from '../../contexts/ScanProxyApiContext';
import { appTransferContextWithDisclosures } from '../../utils/appTransferContextWithDisclosures';

const useGetLatestAmuletPrice: () => UseQueryResult<string, string> = () => {
  const scanProxyApi = useScanProxyApiClient();

  return useQuery({
    queryKey: ['getLatestAmuletPrice', scanProxyApi],
    queryFn: async () => {
      const { latestAmuletPrice } = await appTransferContextWithDisclosures(scanProxyApi, 30);
      return latestAmuletPrice;
    },
  });
};

export default useGetLatestAmuletPrice;
